import { INSTAGRAM_PROFILE_URL, WHATSAPP_CHAT_URL } from "../config/contactLinks";

export const SITE_URL = "https://nigpaktemizlik.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

export type SeoMeta = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: "website" | "article";
  robots?: string;
  jsonLd?: Record<string, unknown> | Array<Record<string, unknown>>;
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "NiğPak Temizlik",
  image: DEFAULT_OG_IMAGE,
  url: SITE_URL,
  telephone: "+90 543 191 0851",
  email: "nigpaktemizlik@gmail.com",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Niğde Merkez",
    addressRegion: "Niğde",
    addressCountry: "TR",
  },
  areaServed: {
    "@type": "City",
    name: "Niğde",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "18:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "09:00",
      closes: "16:00",
    },
  ],
  sameAs: [INSTAGRAM_PROFILE_URL, WHATSAPP_CHAT_URL],
};

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Profesyonel Temizlik Hizmetleri",
  provider: {
    "@type": "LocalBusiness",
    name: "NiğPak Temizlik",
    url: SITE_URL,
  },
  areaServed: {
    "@type": "City",
    name: "Niğde",
  },
};

export const SEO_BY_PATH: Record<string, SeoMeta> = {
  "/": {
    title: "Niğde Temizlik Şirketi | NiğPak Temizlik",
    description:
      "Niğde'de profesyonel temizlik hizmetleri: daire, villa, ofis, inşaat sonrası, cam, koltuk ve halı yıkama. Hızlı teklif için NiğPak Temizlik.",
    keywords:
      "niğde temizlik şirketi, niğde temizlik, niğpak temizlik, villa temizliği niğde, ofis temizliği niğde, inşaat sonrası temizlik niğde",
    path: "/",
    jsonLd: [localBusinessSchema, serviceSchema],
  },
  "/hizmetler": {
    title: "Temizlik Hizmetleri | NiğPak Temizlik Niğde",
    description:
      "Niğde'de 11 farklı profesyonel temizlik hizmeti: inşaat sonrası, daire, ofis, villa, mağaza, restoran, cam, koltuk ve halı temizliği.",
    keywords:
      "temizlik hizmetleri niğde, inşaat sonrası temizlik, daire temizliği, ofis temizliği, cam temizliği, koltuk yıkama niğde",
    path: "/hizmetler",
    jsonLd: {
      ...serviceSchema,
      name: "NiğPak Temizlik Hizmetleri",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Temizlik Hizmet Portföyü",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "İnşaat Sonrası Temizlik" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Daire ve Ofis Temizliği" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Villa Temizliği" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Cam Temizliği" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Koltuk ve Halı Yıkama" } },
        ],
      },
    },
  },
  "/hakkimizda": {
    title: "Hakkımızda | NiğPak Temizlik",
    description:
      "NiğPak Temizlik, Niğde'de 5+ yıllık deneyimi ve 500+ memnun müşteri referansı ile profesyonel temizlik hizmeti sunar.",
    keywords:
      "niğpak hakkında, niğde temizlik firması, profesyonel temizlik ekibi, sigortalı temizlik personeli",
    path: "/hakkimizda",
    jsonLd: localBusinessSchema,
  },
  "/referanslar": {
    title: "Referanslar ve Müşteri Yorumları | NiğPak Temizlik",
    description:
      "NiğPak Temizlik müşteri yorumları ve tamamlanan işlerden gerçek fotoğraflar. Niğde'de güvenilir temizlik deneyimlerini inceleyin.",
    keywords:
      "niğpak referanslar, müşteri yorumları, niğde temizlik yorumları, temizlik öncesi sonrası",
    path: "/referanslar",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "NiğPak Temizlik Referansları",
      about: { "@type": "LocalBusiness", name: "NiğPak Temizlik" },
    },
  },
  "/iletisim": {
    title: "İletişim | NiğPak Temizlik Niğde",
    description:
      "NiğPak Temizlik ile iletişime geçin. Ücretsiz keşif ve hızlı fiyat teklifi için WhatsApp, telefon veya e-posta ile bize ulaşın.",
    keywords:
      "niğpak iletişim, niğde temizlik telefonu, temizlik fiyat teklifi niğde, whatsapp temizlik",
    path: "/iletisim",
    jsonLd: {
      ...localBusinessSchema,
      "@type": "ContactPage",
      mainEntity: {
        "@type": "Organization",
        name: "NiğPak Temizlik",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+90 543 191 0851",
          contactType: "customer service",
          areaServed: "TR-51",
          availableLanguage: ["tr"],
        },
      },
    },
  },
  "/sss": {
    title: "Sık Sorulan Sorular | NiğPak Temizlik",
    description:
      "Temizlik hizmetleri, fiyatlandırma, randevu, ekipman ve süreçlerle ilgili sık sorulan soruların yanıtlarını inceleyin.",
    keywords:
      "temizlik sık sorulan sorular, niğpak sss, temizlik fiyatı nasıl belirlenir, niğde temizlik randevu",
    path: "/sss",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Hangi bölgelere hizmet veriyorsunuz?",
          acceptedAnswer: { "@type": "Answer", text: "Niğde Merkez ve çevresine hizmet veriyoruz." },
        },
        {
          "@type": "Question",
          name: "Fiyatlar nasıl belirleniyor?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Fiyatlar alan büyüklüğü, hizmet türü ve sıklığına göre belirlenir.",
          },
        },
      ],
    },
  },
  "/404": {
    title: "Sayfa Bulunamadı | NiğPak Temizlik",
    description: "Aradığınız sayfa bulunamadı. NiğPak Temizlik ana sayfasına dönerek hizmetlerimizi inceleyebilirsiniz.",
    keywords: "404, sayfa bulunamadı, niğpak",
    path: "/404",
    robots: "noindex, nofollow",
  },
};

